
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns1dfbcf0f62b87c642afe33b46e93a8c6en from './en.yaml'
            i18n.addResourceBundle('en', '1dfbcf0f62b87c642afe33b46e93a8c6', flattenObject(ns1dfbcf0f62b87c642afe33b46e93a8c6en), true, true);
        
        export default '1dfbcf0f62b87c642afe33b46e93a8c6';
    